import { Injectable } from '@angular/core';

import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseService } from '../../../shared/services/Base.service';

@Injectable({
  providedIn: 'root'
})
export class NotificacaoUsuarioSistemaService extends BaseService {
  // BehaviorSubject para emitir notificações
  private notificacoesSubject = new BehaviorSubject<any[]>([]);
  notificacoes$ = this.notificacoesSubject.asObservable();

  constructor() {
    super('/notificacaoUsuarioSistema/');
  }

  // Método para obter notificações
  GetNotificacaoUsuario(): Observable<any> {
    const url = 'ativos';
    return this._http.get(`${this._config.baseUrl}${this._api}${url}`).pipe(
      // Atualiza as notificações no BehaviorSubject
      tap(notificacoes => {
        this.notificacoesSubject.next(Array.isArray(notificacoes) ? notificacoes : []);
      })
    );
  }

  getNotificacoes(): any[] {
    return this.notificacoesSubject.getValue(); // Retorna o valor atual
  }

  // Método para adicionar uma nova notificação (pode ser expandido conforme necessário)
  addNotificacao(novaNotificacao: any): Observable<any> {
    return this._http.post(`${this._config.baseUrl}${this._api}`, novaNotificacao).pipe(
      tap(() => {
        // Após adicionar a nova notificação, atualiza a lista
        this.GetNotificacaoUsuario().subscribe();
      })
    );
  }

  deletePeloUsuarioExportacaoId(usuarioExportacaoId: number): Observable<any> {
    const url = `marcarComoLidaPeloUsuarioExportacao?usuarioExportacaoId=${usuarioExportacaoId}`;
    return this._http.post(`${this._config.baseUrl}${this._api}${url}`, {}).pipe(
      tap(() => {
        // Após deletar as notificações, atualiza a lista
        this.GetNotificacaoUsuario().subscribe();
      })
    );
  }
}
